import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {MatSliderChange} from '@angular/material/slider';
import {ThemePalette} from '@angular/material/core';
import { MDCSlider } from '@material/slider';
import IButton from './types/IButton';


@Component({
  selector: 'app-aktif-button',
  templateUrl: './aktif-button.component.html',
  styleUrls: ['./aktif-button.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class AktifButtonComponent implements OnInit {
  @Input() data: IButton;
  @Input() classname: string = '';
  @Input() disabled: boolean = false;  

  public values: any = {
    value: 0
  }
  
  constructor(
  ) {
    
  }

  ngOnInit(): void {
  }

  getTarget(): string {
    return this.data.item_url.toString().startsWith('http') ? '_blank' : '';
  }
}
